var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('QuizResult',{staticClass:"MemoGamesCard",attrs:{"completed":_vm.done,"title":_vm.$t('title'),"subtitle":_vm.$t('subtitle'),"score":_vm.score,"buttons":_vm.buttons,"icon":"game-icon"},on:{"action":function($event){return _vm.gotoGame()}}})}
var staticRenderFns = []

export { render, staticRenderFns }